export interface TableItemInterface {
  className: string | null;
  icon: string | null;
  keys: IKeyElement[]; // multiple levels will separates with dot
  label: string;
  mandatory?: boolean;
  sortable: boolean;
  tooltip?: string | null;
  tooltipPosition?: string | null;
  type?: string;
  width: string | null;
}

export interface IKeyElement {
  key: string;
  falseKey?: string;
  fallbackKey?: string;
  fallbackConfigWhenNoLungRads?: {
    matchFromFieldPath: string;
    matchToFieldPath: string;
    matchFromKey: string;
    matchToKey: string;
  }
  type: string;
  resource: string;
  defaultValue?: string;
  directValue?: boolean;
  value: { 'class'?: string, 'subKey'?: string, 'classKey'?: string, 'value'?: string, 'subType'?: string};
}
